import { Grid } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { useFormik } from "formik";
import { Dispatch, SetStateAction, useState } from "react";
import RxButton from "../../../components/RxButton";
import RxRadioGroup from "../../../components/RxRadioGroup";
import RxTextField from "../../../components/RxTextField";
import RxTypography from "../../../components/RxTypography";
import api from "../../../config/AxiosConfig";
import { AcademicInfoDTO } from "../../../constants/CommonObject";
import { addNotification } from "../../../redux/slices/notification-slice";
import { store } from "../../../redux/store";
import styles from "../AcademicLicence.module.css";
import AcademicLicenceFormValidation from "./AcademicLicenceFormValidation";
import BarcodeInfoDialog from "./BarcodeInfoDialog";

interface AcademicLicenceFormObject {
	tcNo: string;
	barcode: string;
	licenceType: string;
}

interface AcademicLicenceFormProps {
	setAcademicInfo: Dispatch<SetStateAction<AcademicInfoDTO | undefined>>;
}

const AcademicLicenceForm = (props: AcademicLicenceFormProps) => {
	const [showBarcodeInfo, setShowBarcodeInfo] = useState(false);

	const handleSubmit = async (values: AcademicLicenceFormObject) => {
		await api
			.post<AcademicInfoDTO>(`/1/academic-infos`, {
				student: values.licenceType === "student" ? true : false,
				tcNo: values.tcNo,
				barcode: values.barcode,
			})
			.then((response) => {
				props.setAcademicInfo(response);
				store.dispatch(
					addNotification({
						message: "Akademik lisans başarılı bir şekilde tanımlandı.",
						type: "success",
					})
				);
			});
	};

	const formik = useFormik({
		initialValues: {
			tcNo: "",
			barcode: "",
			licenceType: "student",
		} as AcademicLicenceFormObject,
		validationSchema: AcademicLicenceFormValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: handleSubmit,
	});

	return (
		<form onSubmit={formik.handleSubmit}>
			<Grid
				container
				spacing={1}
				direction="row"
				justifyContent="center"
				alignItems="center"
				alignContent="center"
			>
				<Grid item xs={12} sm={12}>
					<Grid container spacing={8}>
						<Grid item xs={12} sm={12}>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTypography
										variant="h5"
										align="center"
										label={<>Akademik Belge Doğrulama</>}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxRadioGroup
										value={formik.values.licenceType}
										onChange={formik.handleChange}
										id="licenceType"
										ariaLabel="licenceType"
										name="licenceType"
										row
										className={styles.licenceType}
										radioButtons={[
											{
												label: "Öğrenci",
												value: "student",
												color: "primary",
											},
											{
												label: "Akademisyen",
												value: "academician",
												color: "secondary",
											},
										]}
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTextField
										fullwidth
										id="tcNo"
										name="tcNo"
										label="T.C. Kimlik Numarası"
										placeholder="T.C. Kimlik Numarası"
										value={formik.values.tcNo}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										error={
											formik.touched.tcNo &&
											Boolean(formik.errors.tcNo)
										}
										helperText={
											formik.touched.tcNo && formik.errors.tcNo
										}
										required
									/>
								</Grid>
							</Grid>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={12}>
									<RxTextField
										fullwidth
										id="barcode"
										name="barcode"
										label="Belge Barkodu"
										placeholder="Belge Barkodu"
										value={formik.values.barcode}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										error={
											formik.touched.barcode &&
											Boolean(formik.errors.barcode)
										}
										helperText={
											formik.touched.barcode && formik.errors.barcode
										}
										inputEndAdornment={
											<InfoOutlined
												style={{ cursor: "pointer" }}
												onClick={() => {
													setShowBarcodeInfo(true);
												}}
											/>
										}
										required
									/>
								</Grid>
							</Grid>
							<Grid container justifyContent="center" spacing={1}>
								<Grid item xs={12} sm={4}>
									<RxButton
										className={styles.submitButton}
										fullWidth
										color={"primary"}
										variant="contained"
										label="Doğrula"
										type="submit"
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<BarcodeInfoDialog
				show={showBarcodeInfo}
				licenceType={formik.values.licenceType}
				onClose={() => setShowBarcodeInfo(false)}
			/>
		</form>
	);
};

export default AcademicLicenceForm;
